import { render, staticRenderFns } from "./main-magazine.vue?vue&type=template&id=58eb1482&scoped=true&"
import script from "./main-magazine.vue?vue&type=script&lang=js&"
export * from "./main-magazine.vue?vue&type=script&lang=js&"
import style0 from "./main-magazine.vue?vue&type=style&index=0&id=58eb1482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eb1482",
  null
  
)

export default component.exports